import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FontOverseasReturnOrderList from '../entities/font-overseasreturnorder'
import UpdateBackAbroadOrderStatu from '@/store/entities/back-order-update-statu'
import createdata from '@/store/entities/create-order'
import appconst from '@/lib/appconst';
interface FontOverseasReturnOrderState extends ListState<FontOverseasReturnOrderList> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

interface FontOverseasReturnOrderState extends ListState<FontOverseasReturnOrderList> {
    orderInfo: createdata,

}
class BackAbroadOrderMutations extends ListMutations<FontOverseasReturnOrderList>{

}
class FontOverseasReturnbroadOrder extends ListModule<FontOverseasReturnOrderState, any, FontOverseasReturnOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        orderInfo: new createdata(),
        list: new Array<FontOverseasReturnOrderList>(),
      
        loading: false,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<FontOverseasReturnOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontAbroadReturn/GetReturnOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FontOverseasReturnOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        async createOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadReturn/CreateReturnOrder', payload.data);
        },
        async orderBale(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadReturn/AbroadOrderBale', payload.data);
        },
        //��������
        async cancleOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadReturn/CancleOrder?orderId=' + payload.data.orderId);
        },
        //��������쳣
        async normalOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadReturn/NormalOrder?id=' + payload.data.id);
        },
        async updatePackageStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontAbroadReturn/ProcessOrderPackageStatus', payload.data);
        },
        async oneClickDelivery(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontAbroadReturn/OneClickDelivery');
        },
        async getOrder(context: ActionContext<FontOverseasReturnOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontAbroadOrder/GetOrderInfo?id=' + payload.data.id);
            context.state.orderInfo = (reponse.data.result as createdata);
        },
        //�༭�˼�����
        async addRerurnOrder(context: ActionContext<FontOverseasReturnOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontAbroadReturn/AddRerurnOrder?orderId=' + payload.data.orderId + '&returnNumber=' + payload.data.returnNumber + '&orderNumber=' + payload.data.orderNumber);
            context.state.orderInfo = (reponse.data.result as createdata);
        },
    };
    mutations = {
        setCurrentPage(state: FontOverseasReturnOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontOverseasReturnOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        getPdf(state: FontOverseasReturnOrderState, data: any) {
            if (data.pdfGuid && data.pdfGuid.length > 1) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid + "&id=" + (data.userId ? data.userId : abp.session.userId) + "&orderNumber=" + data.orderNumber);
            }
        }
    }
}

const fontoverseasreturnorders = new FontOverseasReturnbroadOrder();
export default fontoverseasreturnorders;